export default __webpack_public_path__ + "static/media/Futura-LT-Book.77924e4e.otf";